import { render, staticRenderFns } from "./Anchors.vue?vue&type=template&id=26f99580&scoped=true&"
import script from "./Anchors.vue?vue&type=script&lang=ts&"
export * from "./Anchors.vue?vue&type=script&lang=ts&"
import style0 from "./Anchors.vue?vue&type=style&index=0&id=26f99580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f99580",
  null
  
)

export default component.exports